import React, { useEffect, useState } from 'react'
import { setDir, isRTL, getQueryString } from '@common/utils/dom'
import { getLocale } from '@common/utils/getCNLocale'
import { getLinkUrl, getLanguageText } from './utils'
import mijiaLogo from './assets/mijia-logo.png'
import {
  Profile,
  Identifier,
  Calendar,
  Location,
  Device,
  Diagnosis,
  Interaction,
  City,
  Right,
  MijiaLogo
} from './components/Icons'

// 获取当前语言
const parsedLanguage = getLocale()
// 判断语言方向
setDir(parsedLanguage)
const isRTLLang = isRTL(parsedLanguage)
// 根据语言获取文本内容
const TEXT = getLanguageText(parsedLanguage)
document.title = TEXT.title

export default function Page() {
  return (
    <div className="app">
      <div className='logo-wrap'>
        <div className={`mijia-logo ${isRTLLang && 'isRTLLang'}`}>
          <MijiaLogo></MijiaLogo>
        </div>
        <div className='mijia-detail'>
          <div className='name'>{TEXT.mi_home}</div>
          <div className='version'>{TEXT.version} {getQueryString('platform')} {getQueryString('version')}</div>
        </div>
      </div>
      <div className='section'>
        <div className='section-title'>
          <div className='title'>{TEXT.data_collection}</div>
          <a className='right link' href={getLinkUrl('collect')}>{TEXT.view_details}</a>
        </div>
        <div className='section-desc' dangerouslySetInnerHTML={{__html: TEXT.view_full_version.replace('%1$s', getLinkUrl('privacy'))}}></div>
        <div className='section-detail'>
          <div className='detail-title'>{TEXT.related_data}</div>
          <div className='detail-desc'>{TEXT.collect_data}</div>
          <div className='detail-item-wrap'>
            <div className='detail-item half'>
              <div className='icon'><Profile></Profile></div>
              <div className='name'>{TEXT.basic_info}</div>
            </div>
            <div className='detail-item half'>
              <div className='icon'><Identifier></Identifier></div>
              <div className='name'>{TEXT.identifier}</div>
            </div>
            <div className='detail-item half'>
              <div className='icon'><Calendar></Calendar></div>
              <div className='name'>{TEXT.content_data}</div>
            </div>
            <div className='detail-item half'>
              <div className='icon'><Location></Location></div>
              <div className='name'>{TEXT.location}</div>
            </div>
            <div className='detail-item half'>
              <div className='icon'><Device></Device></div>
              <div className='name'>{TEXT.sys_info}</div>
            </div>
            <div className='detail-item half'>
              <div className='icon'><Interaction></Interaction></div>
              <div className='name'>{TEXT.interaction_data}</div>
            </div>
          </div>
        </div>
        <div className='section-detail'>
          <div className='detail-title'>{TEXT.unrelated_data}</div>
          <div className='detail-desc'>{TEXT.unrelated_collect}</div>
          <div className='detail-item-wrap'>
            <div className='detail-item'>
              <div className='icon'><Diagnosis></Diagnosis></div>
              <div className='name'>{TEXT.diagnostic_info}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='section-title'>
          <div className='title'>{TEXT.data_sharing}</div>
          <a className='right link' href={getLinkUrl('share')}>{TEXT.view_details}</a>
        </div>
        <div className='section-desc'>{TEXT.share_with_follow}</div>
        <div className='section-detail'>
          <div className='detail-item-wrap'>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.gaode}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.tencent}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.microdream}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.huawei}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.oppo}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><City></City></div>
              <div className='name'>{TEXT.alipay}</div>
            </div>
            <div className='detail-ellipsis'>......</div>
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='section-title'>
          <div className='title'>{TEXT.security}</div>
        </div>
        <div className='section-desc'>{TEXT.measure}</div>
        <div className='section-detail'>
          <div className='detail-item-wrap'>
            <div className='detail-item mg0'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.encrypt_local}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.encrypt_transmit}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.encrypt_server}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.access_control}</div>
            </div>
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='section-title'>
          <div className='title'>{TEXT.rights}</div>
        </div>
        <div className='section-desc'>{TEXT.privacy_desc}</div>
        <div className='section-detail'>
          <div className='detail-item-wrap'>
            <div className='detail-item mg0'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.cancel_account}</div>
            </div>
            <div className='detail-item'>
              <div className='icon'><Right></Right></div>
              <div className='name'>{TEXT.close_recommend}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
